import { SOUNDS_URL } from './urls'

export const playNotifSound = (type = 'NEW_MSG') => {
  const NOTIF_ENDPOINT_BY_TYPE = {
    NEW_MSG: 'notification.0d062b33cp.mp3',
    MSG_SENT: 'submit.9b6dc5c5.mp3',
    MSG_RECEIVED: 'notification.0d062b33cp.mp3',
  }

  const url = `${SOUNDS_URL}/${NOTIF_ENDPOINT_BY_TYPE[type]}`

  try {
    const audio = new Audio(url)
    audio.play()
  } catch (error) {
    console.log(error)
  }
}
